export function SecureIcon() {
  return (
    <svg
      width="28"
      height="32"
      viewBox="0 0 28 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 14V10C4 7.34784 5.05357 4.8043 6.92893 2.92893C8.8043 1.05357 11.3478 0 14 0C16.6522 0 19.1957 1.05357 21.0711 2.92893C22.9464 4.8043 24 7.34784 24 10V14C25.0609 14 26.0783 14.4214 26.8284 15.1716C27.5786 15.9217 28 16.9391 28 18V28C28 29.0609 27.5786 30.0783 26.8284 30.8284C26.0783 31.5786 25.0609 32 24 32H4C2.93913 32 1.92172 31.5786 1.17157 30.8284C0.421427 30.0783 0 29.0609 0 28V18C0 16.9391 0.421427 15.9217 1.17157 15.1716C1.92172 14.4214 2.93913 14 4 14ZM20 10V14H8V10C8 8.4087 8.63214 6.88258 9.75736 5.75736C10.8826 4.63214 12.4087 4 14 4C15.5913 4 17.1174 4.63214 18.2426 5.75736C19.3679 6.88258 20 8.4087 20 10Z"
        fill="url(#paint0_radial_559_3250)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_559_3250"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-122.111 -253.334) scale(302.555 345.779)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#734CE2" />
        </radialGradient>
      </defs>
    </svg>
  )
}
